module.exports = __webpack_public_path__ + "img/overview.1ba1890f.svg";